import { Icon } from '@antimatterhq/ui/components/icon';
import { useNavigate } from 'react-router-dom';
import { Text } from '@antimatterhq/ui/components/typography';
import { Button } from '@antimatterhq/ui/components/button';
import { dbui_v1_Notable } from '@antimatterhq/asl-api-ts-v1';

type PaginationInDetailsViewProps = {
  currentId: string;
};

// TODO: This is quite broken, this will not play nice with server pagination so I think we should
// remove this
export const PaginationInDetailsView = ({
  currentId,
}: PaginationInDetailsViewProps) => {
  const notables = [] as dbui_v1_Notable[];
  const navigate = useNavigate();

  const currentNotableIndex = notables.findIndex(
    (notable) => notable.id === currentId,
  );

  // If user gets to this page with direct link, we don't want to show the pagination
  if (notables.length === 0) return null;

  const previousNotable = notables[currentNotableIndex - 1];
  const nextNotable = notables[currentNotableIndex + 1];

  const handlePreviousNotable = () => {
    navigate(`/explore/notables/${previousNotable.id}`);
  };

  const handleNextNotable = () => {
    navigate(`/explore/notables/${nextNotable.id}`);
  };

  return (
    <div className="flex items-center gap-2">
      <Text size="sm">
        {currentNotableIndex + 1} of {notables.length}
      </Text>

      <Button
        iconOnly
        variant={'ghost'}
        disabled={!previousNotable}
        onClick={handlePreviousNotable}
      >
        <Icon icon="lucide:chevron-left" />
      </Button>
      <Button
        iconOnly
        variant={'ghost'}
        disabled={!nextNotable}
        onClick={handleNextNotable}
      >
        <Icon icon="lucide:chevron-right" />
      </Button>
    </div>
  );
};
